import React from "react";
import "../admin/dashboard-redesign.css";

function FlexibleStatsCard({ label, value, detail, tone = "neutral", icon, onClick, isFirst = false, isLast = false }) {
  const content = (
    <>
      <div className={`dashboard-status-card__icon tone-${tone}`}>
        {icon}
      </div>
      <div className="dashboard-status-card__content">
        <span className="dashboard-status-card__label">{label}</span>
        <strong className="dashboard-status-card__value">{value}</strong>
        <span className="dashboard-status-card__detail">{detail}</span>
      </div>
    </>
  );

  if (typeof onClick === "function") {
    return (
      <button
        className={`dashboard-status-card tone-${tone} ${isFirst ? "is-first" : ""} ${isLast ? "is-last" : ""}`}
        type="button"
        onClick={onClick}
      >
        {content}
      </button>
    );
  }

  return (
    <div className={`dashboard-status-card tone-${tone} ${isFirst ? "is-first" : ""} ${isLast ? "is-last" : ""}`}>
      {content}
    </div>
  );
}

export default function FlexibleStatsRow({ items = [] }) {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <section
      className="dashboard-status-grid"
      style={{ "--status-grid-columns": items.length }}
    >
      {items.map((item, index) => {
        const { key, ...cardProps } = item || {};

        return (
          <FlexibleStatsCard
            key={key || item?.label || index}
            {...cardProps}
            isFirst={index === 0}
            isLast={index === items.length - 1}
          />
        );
      })}
    </section>
  );
}
